import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { Formik } from "formik";
import { cloneDeep } from "lodash";
import React, { useEffect, useState } from "react";
import { Button, Offcanvas } from "react-bootstrap";
import * as Yup from "yup";

import { BPIRevenueFinancialParticularsForm } from "..";

import { IFinancialParticulars } from "../../../../config/interfaces";
import {
  FinancialParticularFormInitValues,
  FinancialParticularsFormSchema
} from "../../../../pages/itr-filing/efiling.config";
import { useAppSelector } from "../../../../redux/Store";
import { ITRFilingSelector } from "../../../../redux/slice/ITRFilingSlice";
import FASvgIcon from "../../../FASvgIcon";
import ScrollToFirstError from "../../../ScrollToFirstError";

type Props = {
  showCanvas: boolean;
  formValues: IFinancialParticulars | null;
  handleCloseBtnPress: (IFinancialParticulars: IFinancialParticulars | null) => void;
};

const BPIFinancialParticularsDetailsForm: React.FC<Props> = (props: Props) => {
  const { showCanvas, handleCloseBtnPress, formValues } = props;

  const { isFilingReadOnly } = useAppSelector(ITRFilingSelector);

  const [initFormValues, setInitFormValues] = useState<IFinancialParticulars>(
    FinancialParticularFormInitValues
  );

  useEffect(() => {
    if (showCanvas && formValues) {
      setInitFormValues(() => cloneDeep(formValues));
    } else {
      setInitFormValues(() => cloneDeep(FinancialParticularFormInitValues));
    }
  }, [showCanvas, formValues]);

  return (
    <>
      <Offcanvas show={showCanvas} placement="end" backdrop={true}>
        <Formik
          enableReinitialize={true}
          initialValues={initFormValues}
          validationSchema={Yup.object().shape({ ...FinancialParticularsFormSchema })}
          onSubmit={(values) => {
            handleCloseBtnPress(values);
          }}
        >
          {({ handleSubmit, validateForm, submitCount, isValid, errors }) => (
            <>
              <ScrollToFirstError submitCount={submitCount} isValid={isValid} errors={errors} />

              <Offcanvas.Header>
                <Offcanvas.Title>Financial Particulars Details</Offcanvas.Title>
                <Button
                  variant="primary"
                  className="icon-only hide-offcanvas"
                  onClick={() => handleCloseBtnPress(null)}
                >
                  <FASvgIcon icon={faXmark} />
                </Button>
              </Offcanvas.Header>

              <Offcanvas.Body>
                <BPIRevenueFinancialParticularsForm />
              </Offcanvas.Body>

              <div className="offcanvas-btns">
                {!isFilingReadOnly ? (
                  <Button
                    variant="outline-white"
                    size="sm"
                    onClick={async (event) => {
                      event.preventDefault();
                      await validateForm();
                      handleSubmit();
                    }}
                  >
                    Save and Close
                  </Button>
                ) : (
                  <Button
                    variant="outline-white"
                    size="sm"
                    onClick={() => handleCloseBtnPress(null)}
                  >
                    Close
                  </Button>
                )}
              </div>
            </>
          )}
        </Formik>
      </Offcanvas>
    </>
  );
};

export default BPIFinancialParticularsDetailsForm;
